// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EpUJPrwz8Q1KtNjO {
  color: blue;
}

.liK3eBLFe_o2X9A4 {
  padding-top: 10px;
  max-width: 1200px;
  margin: 0 auto;
  height: 100vh;
}

.UJSaIR5zyE436rCW {
  height: 90px;
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.UJSaIR5zyE436rCW img {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".test {\r\n  color: blue;\r\n}\r\n\r\n.mainWrapper {\r\n  padding-top: 10px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  height: 100vh;\r\n}\r\n\r\n.header {\r\n  height: 90px;\r\n  background-color: #ffffff;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.header img {\r\n  height: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var test = `EpUJPrwz8Q1KtNjO`;
export var mainWrapper = `liK3eBLFe_o2X9A4`;
export var header = `UJSaIR5zyE436rCW`;
export default ___CSS_LOADER_EXPORT___;
